// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBEASfvBDTYERKJmTVh_VWt7OyqOtADcGQ",
  authDomain: "myunde786.firebaseapp.com",
  projectId: "myunde786",
  storageBucket: "myunde786.firebasestorage.app",
  messagingSenderId: "655033035589",
  appId: "1:655033035589:web:5bdfd319acde5250382c2c",
  measurementId: "G-SQGWXGRR4M",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
